import { environment } from "src/environments/environment";

export const constant  = {
    downloadResultFile: environment.KUDOSHUB_JAVA_HOST_URL + "api/download-result-files?file_uid=",
    apiUrl: environment.KUDOSHUB_JAVA_HOST_URL + "api/user/export-event-details",
    offerPopupTime: 120000
}